const baseURL = process.env.REACT_APP_BASE_URL;
const wsbaseURL = process.env.REACT_APP_WS_URL;

const xmpp_domain = process.env.REACT_APP_XMPP_DOMAIN;
const FILE_SERVER = process.env.REACT_APP_FILE_SERVER;
const return_data = {
    "FILE_SERVER": FILE_SERVER,
    "baseURL": baseURL,
    "xmpp_domain": xmpp_domain,
}
export { return_data, FILE_SERVER, baseURL, wsbaseURL };
